import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BlobService {
	constructor(private readonly httpClient: HttpClient) {}

	async getBlob(url: string) {
		return firstValueFrom(this.httpClient.get(url, { responseType: 'blob' }));
	}
}
